"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModalConditions = getModalConditions;
var services_1 = require("@falcon/services");
function getModalConditions(bindFromField, interaction, useOnlyCourtesyCarTotalLoss) {
    var mleIncluded = bindFromField("optionalExtras.motorLegalExpenses");
    var ghcIncluded = useOnlyCourtesyCarTotalLoss
        ? bindFromField("optionalExtras.courtesyCarTotalLoss")
        : bindFromField("optionalExtras.courtesyCar");
    var isEssentialsTier = interaction.coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1;
    var isSilverTier = interaction.coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2;
    var tierEligibility = bindFromField("tierEligibility");
    var tiersAvailable = function (tiers, matchAll) {
        var tiersEligible = tiers.map(function (requiredTier) { return !!(tierEligibility === null || tierEligibility === void 0 ? void 0 : tierEligibility[requiredTier]); });
        return matchAll ? tiersEligible.every(Boolean) : tiersEligible.some(Boolean);
    };
    return [
        {
            isModalShown: interaction.uistate.modalShownEssentialsGHCAndMLESelected,
            stateKey: "showModalEssentialsGHCAndMLESelected",
            uiStateKey: "uistate.modalShownEssentialsGHCAndMLESelected",
            conditionCheck: function () { return mleIncluded && ghcIncluded && isEssentialsTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownEssentialsGHCSelected,
            stateKey: "showModalEssentialsGHCSelected",
            uiStateKey: "uistate.modalShownEssentialsGHCSelected",
            conditionCheck: function () { return !mleIncluded && !useOnlyCourtesyCarTotalLoss && ghcIncluded && isEssentialsTier && tiersAvailable(["allianz", "silver"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownEssentialsGHCTotalLossSelected,
            stateKey: "showModalEssentialsGHCTotalLossSelected",
            uiStateKey: "uistate.modalShownEssentialsGHCTotalLossSelected",
            conditionCheck: function () { return !mleIncluded && useOnlyCourtesyCarTotalLoss && ghcIncluded && isEssentialsTier && tiersAvailable(["allianz", "silver"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownEssentialsMLESelected,
            stateKey: "showModalEssentialsMLESelected",
            uiStateKey: "uistate.modalShownEssentialsMLESelected",
            conditionCheck: function () { return mleIncluded && !ghcIncluded && isEssentialsTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownSilverMLESelected,
            stateKey: "showModalSilverMLESelected",
            uiStateKey: "uistate.modalShownSilverMLESelected",
            conditionCheck: function () { return !ghcIncluded && mleIncluded && isSilverTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownSilverGHCSelected,
            stateKey: "showModalSilverGHCSelected",
            uiStateKey: "uistate.modalShownSilverGHCSelected",
            conditionCheck: function () { return !mleIncluded && ghcIncluded && isSilverTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownSilverGHCAndMLESelected,
            stateKey: "showModalSilverGHCAndMLESelected",
            uiStateKey: "uistate.modalShownSilverGHCAndMLESelected",
            conditionCheck: function () { return mleIncluded && ghcIncluded && isSilverTier && tiersAvailable(["allianz"], false); },
        }
    ];
}
//# sourceMappingURL=AnnualMotorTierUpgradeModalConditions.js.map